import React from 'react';
import { Image, Video } from 'lucide-react';

interface FeedToggleProps {
  value: 'snaps' | 'drools';
  onValueChange: (value: 'snaps' | 'drools') => void;
}

const FeedToggle: React.FC<FeedToggleProps> = ({ value, onValueChange }) => {
  return (
    <div className="flex items-center gap-1 bg-black/40 backdrop-blur-md rounded-full p-1 border border-white/10">
      <button
        onClick={() => onValueChange('snaps')}
        className={`flex items-center px-3 py-2 rounded-full transition-all ${
          value === 'snaps'
            ? 'bg-[#cfef00] text-black'
            : 'text-white/70 hover:text-white'
        }`}
      >
        <Image className="w-4 h-4" />
      </button>
      <button
        onClick={() => onValueChange('drools')}
        className={`flex items-center px-3 py-2 rounded-full transition-all ${
          value === 'drools'
            ? 'bg-[#cfef00] text-black'
            : 'text-white/70 hover:text-white'
        }`}
      >
        <Video className="w-4 h-4" />
      </button>
    </div>
  );
};

export default FeedToggle;
